import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-1cb67830")
const _hoisted_1 = {
  key: 0,
  class: "table"
}
const _hoisted_2 = {
  scope: "col",
  class: "text-center",
  colspan: "2"
}
const _hoisted_3 = {
  class: "text-center",
  colspan: "2",
  variant: "secondary"
}
const _hoisted_4 = {
  class: "text-center",
  variant: "secondary"
}
const _hoisted_5 = { class: "text-center" }
const _hoisted_6 = { class: "text-center" }
const _hoisted_7 = { class: "text-center" }
const _hoisted_8 = { class: "text-center" }
const _hoisted_9 = { class: "text-center" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = {
  class: "text-center",
  colspan: "2",
  variant: "secondary"
}
const _hoisted_12 = { class: "table game-info" }
const _hoisted_13 = { class: "text-center" }
const _hoisted_14 = { class: "text-center" }
const _hoisted_15 = { class: "text-center" }
const _hoisted_16 = { class: "text-center" }
const _hoisted_17 = { class: "text-center" }
const _hoisted_18 = { class: "text-center" }
const _hoisted_19 = { class: "text-center" }
const _hoisted_20 = { class: "text-center" }
const _hoisted_21 = { class: "text-center" }
const _hoisted_22 = { class: "text-center" }
const _hoisted_23 = { class: "text-center" }
const _hoisted_24 = { class: "text-center" }
const _hoisted_25 = { class: "text-center" }
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.result)
    ? (_openBlock(), _createElementBlock("table", _hoisted_1, [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", null, [
            _createElementVNode("th", _hoisted_2, _toDisplayString(_ctx.$t(`gameData.header`)), 1)
          ])
        ]),
        _createElementVNode("tbody", null, [
          _createElementVNode("tr", null, [
            _createElementVNode("td", _hoisted_3, _toDisplayString(_ctx.$t(`gameData.playerName`)) + ": " + _toDisplayString(_ctx.result.agent + "_" + _ctx.result.member), 1)
          ]),
          _createElementVNode("tr", null, [
            _createElementVNode("td", _hoisted_4, _toDisplayString(_ctx.$t(`gameData.game`)), 1),
            _createElementVNode("td", _hoisted_5, _toDisplayString(_ctx.result.game), 1)
          ]),
          _createElementVNode("tr", null, [
            _createElementVNode("td", _hoisted_6, _toDisplayString(_ctx.$t(`gameData.tableId`)), 1),
            _createElementVNode("td", _hoisted_7, _toDisplayString(_ctx.result.roomno) + " " + _toDisplayString(_ctx.result.roomorder), 1)
          ]),
          _createElementVNode("tr", null, [
            _createElementVNode("td", _hoisted_8, _toDisplayString(_ctx.$t(`gameData.playerHand`)), 1),
            _createElementVNode("td", _hoisted_9, _toDisplayString(_ctx.$t(`gameData.bankerHand`)), 1)
          ]),
          _createElementVNode("tr", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.result.game_cards, (res, idx) => {
              return (_openBlock(), _createElementBlock("td", {
                class: "text-center",
                key: idx
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(res.cards, (card, i) => {
                  return (_openBlock(), _createElementBlock("span", {
                    class: _normalizeClass(["card-data banker-card", { hideCard: card == `` }]),
                    key: i
                  }, [
                    _createElementVNode("span", {
                      class: _normalizeClass(["card-image", String(card).toLowerCase()])
                    }, null, 2)
                  ], 2))
                }), 128)),
                _hoisted_10,
                _createTextVNode(" " + _toDisplayString(res.score), 1)
              ]))
            }), 128))
          ]),
          _createElementVNode("tr", null, [
            _createElementVNode("td", _hoisted_11, [
              _createElementVNode("table", _hoisted_12, [
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", _hoisted_13, _toDisplayString(_ctx.$t(`gameData.bets`)), 1),
                    _createElementVNode("td", _hoisted_14, _toDisplayString(_ctx.$t(`gameData.amount`)), 1),
                    _createElementVNode("td", _hoisted_15, _toDisplayString(_ctx.$t(`gameData.netCash`)), 1),
                    _createElementVNode("td", _hoisted_16, _toDisplayString(_ctx.$t(`gameData.placeTime`)), 1),
                    _createElementVNode("td", _hoisted_17, _toDisplayString(_ctx.$t(`gameData.status.label`)), 1)
                  ])
                ]),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.result.positions, (bet, idx) => {
                    return (_openBlock(), _createElementBlock("tr", { key: idx }, [
                      _createElementVNode("td", null, _toDisplayString(bet.betposition), 1),
                      _createElementVNode("td", null, _toDisplayString(_ctx.$n(parseInt(bet.betamount), "currency")), 1),
                      _createElementVNode("td", null, _toDisplayString(_ctx.$n(parseInt(bet.winamount), "currency")), 1),
                      _createElementVNode("td", null, _toDisplayString(bet.createdAt), 1),
                      _createElementVNode("td", null, _toDisplayString(_ctx.$t(`gameData.status.` + bet.state)), 1)
                    ]))
                  }), 128))
                ])
              ])
            ])
          ]),
          _createElementVNode("tr", null, [
            _createElementVNode("td", _hoisted_18, _toDisplayString(_ctx.$t(`gameData.results`)), 1),
            _createElementVNode("td", _hoisted_19, _toDisplayString(_ctx.$t(`gameData.result.` + _ctx.result.game_result)), 1)
          ]),
          _createElementVNode("tr", null, [
            _createElementVNode("td", _hoisted_20, _toDisplayString(_ctx.$t(`gameData.totalBet`)), 1),
            _createElementVNode("td", _hoisted_21, _toDisplayString(_ctx.$n(_ctx.totalBet, "currency")), 1)
          ]),
          _createElementVNode("tr", null, [
            _createElementVNode("td", _hoisted_22, _toDisplayString(_ctx.$t(`gameData.totalPayout`)), 1),
            _createElementVNode("td", _hoisted_23, _toDisplayString(_ctx.$n(_ctx.totalWin, "currency")), 1)
          ]),
          _createElementVNode("tr", null, [
            _createElementVNode("td", _hoisted_24, _toDisplayString(_ctx.$t(`gameData.totalNet`)), 1),
            _createElementVNode("td", _hoisted_25, _toDisplayString(_ctx.$n(_ctx.totalNet, "currency")), 1)
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}